export default ({ request }) => ({
  mrpStockTransferListApi(data = {}) {
    return request({
      url: '/factory/mrp/stock/transfer/list',
      method: 'post',
      data,
    })
  },
  mrpStockTransferDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/stock/transfer/detail',
      method: 'post',
      data,
    })
  },
  mrpStockTransferSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/stock/transfer/save',
      method: 'post',
      data,
    })
  },
  mrpStockTransferDelApi(data = {}) {
    return request({
      url: '/factory/mrp/stock/transfer/del',
      method: 'post',
      data,
    })
  },
  mrpStockTransferSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/stock/transfer/submit',
      method: 'post',
      data,
    })
  },
})
